module.exports = __webpack_public_path__ + "static/img/loading.868de8b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 2